const cashflow = {
    "start_date": "2019-01-03",
    "end_date": "2020-12-09",
    "transaction_count": 1599,
    "currency": "AED",
    "incoming": {
        "all_transactions": {
            "mean_per_month": {
                "last_12_months": 40443.81,
                "last_18_months": 46497.26,
                "last_24_months": 46917.35,
                "since_first_transaction": 46917.35
            },
            "raw_monthly_totals": [
                12476.62,
                55046.62,
                21056.51,
                95494.7,
                124378.08,
                46029.04,
                22838.45,
                52890.0,
                3.69,
                16307.18,
                37675.47,
                1129.32
            ]
        },
        "regular_transactions": {
            "mean_per_month": {
                "last_12_months": 0.0,
                "last_18_months": 3476.19,
                "last_24_months": 9125.0,
                "since_first_transaction": 9125.0
            },
            "raw_monthly_totals": [
                0.0,
                0.0,
                0.0,
                0.0,
                0.0,
                0.0,
                0.0,
                0.0,
                0.0,
                0.0,
                0.0,
                0.0
            ]
        }
    },
    "outgoing": {
        "all_transactions": {
            "mean_per_month": {
                "last_12_months": 35733.74,
                "last_18_months": 44113.97,
                "last_24_months": 47124.46,
                "since_first_transaction": 47124.46
            },
            "raw_monthly_totals": [
                79730.9,
                34918.85,
                33306.74,
                43213.95,
                65522.1,
                68258.91,
                14112.24,
                30729.57,
                12975.37,
                26135.3,
                19441.5,
                459.47
            ]
        },
        "regular_transactions": {
            "mean_per_month": {
                "last_12_months": 53.14,
                "last_18_months": 906.35,
                "last_24_months": 1234.32,
                "since_first_transaction": 1234.32
            },
            "raw_monthly_totals": [
                318.83,
                318.83,
                0.0,
                0.0,
                0.0,
                0.0,
                0.0,
                0.0,
                0.0,
                0.0,
                0.0,
                0.0
            ]
        }
    },
    "repeating_transactions": [
        {
            "description_normalized": "installment plan emi souq com fz llc ",
            "category": "LOANS_AND_INVESTMENTS",
            "direction": "EXPENSE",
            "is_recurring": true,
            "mean_amount": 333.17,
            "median_amount": 333.17,
            "stability": 1.0,
            "mean_monthly_sum": 333.17,
            "count": 6,
            "start_date": "2019-03-25",
            "end_date": "2019-08-25",
            "mean_days_between_transactions": 30.6,
            "regularity": 0.97
        },
        {
            "description_normalized": "salary credit salary am prc",
            "category": "SALARY_AND_REVENUE",
            "direction": "INCOME",
            "is_recurring": true,
            "mean_amount": 31285.71,
            "median_amount": 30000.0,
            "stability": 0.92,
            "mean_monthly_sum": 31285.71,
            "count": 7,
            "start_date": "2019-02-24",
            "end_date": "2019-08-25",
            "mean_days_between_transactions": 30.33,
            "regularity": 0.96
        },
        {
            "description_normalized": "tala jewellery ",
            "category": "LOANS_AND_INVESTMENTS",
            "direction": "EXPENSE",
            "is_recurring": true,
            "mean_amount": 6181.82,
            "median_amount": 6181.82,
            "stability": 1.0,
            "mean_monthly_sum": 6181.82,
            "count": 3,
            "start_date": "2019-06-25",
            "end_date": "2019-08-25",
            "mean_days_between_transactions": 30.5,
            "regularity": 0.96
        },
        {
            "description_normalized": "westzone supermarket",
            "category": "GROCERIES",
            "direction": "EXPENSE",
            "is_recurring": true,
            "mean_amount": 16.85,
            "median_amount": 12.75,
            "stability": 0.53,
            "mean_monthly_sum": 25.28,
            "count": 3,
            "start_date": "2019-06-23",
            "end_date": "2019-07-31",
            "mean_days_between_transactions": 19.0,
            "regularity": 0.8
        },
        {
            "description_normalized": "peluqureria women salon",
            "category": "HEALTH_AND_WELLBEING",
            "direction": "EXPENSE",
            "is_recurring": true,
            "mean_amount": 318.83,
            "median_amount": 150.0,
            "stability": 0.32,
            "mean_monthly_sum": 318.83,
            "count": 3,
            "start_date": "2019-12-04",
            "end_date": "2020-10-18",
            "mean_days_between_transactions": 159.5,
            "regularity": 0.7
        },
        {
            "description_normalized": "dial a nail",
            "category": "HEALTH_AND_WELLBEING",
            "direction": "EXPENSE",
            "is_recurring": true,
            "mean_amount": 92.7,
            "median_amount": 75.0,
            "stability": 0.62,
            "mean_monthly_sum": 92.7,
            "count": 5,
            "start_date": "2019-02-28",
            "end_date": "2019-06-30",
            "mean_days_between_transactions": 30.5,
            "regularity": 0.64
        },
        {
            "description_normalized": "namshi general trading",
            "category": "RETAIL",
            "direction": "EXPENSE",
            "is_recurring": true,
            "mean_amount": 424.6,
            "median_amount": 373.12,
            "stability": 0.53,
            "mean_monthly_sum": 424.6,
            "count": 5,
            "start_date": "2019-07-03",
            "end_date": "2020-03-09",
            "mean_days_between_transactions": 62.5,
            "regularity": 0.62
        },
        {
            "description_normalized": "vat on processing fee",
            "category": "BANK_FEES_AND_CHARGES",
            "direction": "EXPENSE",
            "is_recurring": true,
            "mean_amount": 2.45,
            "median_amount": 2.45,
            "stability": 1.0,
            "mean_monthly_sum": 2.45,
            "count": 3,
            "start_date": "2019-10-03",
            "end_date": "2020-09-13",
            "mean_days_between_transactions": 173.0,
            "regularity": 0.54
        },
        {
            "description_normalized": "installment plan processing fee",
            "category": "BANK_FEES_AND_CHARGES",
            "direction": "EXPENSE",
            "is_recurring": true,
            "mean_amount": 49.0,
            "median_amount": 49.0,
            "stability": 1.0,
            "mean_monthly_sum": 49.0,
            "count": 3,
            "start_date": "2019-10-03",
            "end_date": "2020-09-13",
            "mean_days_between_transactions": 173.0,
            "regularity": 0.54
        },
        {
            "description_normalized": "service chgs atm card no dubai ae ",
            "category": "BANK_FEES_AND_CHARGES",
            "direction": "EXPENSE",
            "is_recurring": true,
            "mean_amount": 2.0,
            "median_amount": 2.0,
            "stability": 1.0,
            "mean_monthly_sum": 2.0,
            "count": 3,
            "start_date": "2019-04-14",
            "end_date": "2019-09-04",
            "mean_days_between_transactions": 71.5,
            "regularity": 0.51
        },
        {
            "description_normalized": "uae switch wdl dubai ae",
            "category": "RENT_AND_SERVICES",
            "direction": "EXPENSE",
            "is_recurring": true,
            "mean_amount": 1766.67,
            "median_amount": 200.0,
            "stability": 0.27,
            "mean_monthly_sum": 1766.67,
            "count": 3,
            "start_date": "2019-04-14",
            "end_date": "2019-09-04",
            "mean_days_between_transactions": 71.5,
            "regularity": 0.51
        },
        {
            "description_normalized": "protect plus premium reversal",
            "category": "RENT_AND_SERVICES",
            "direction": "EXPENSE",
            "is_recurring": false,
            "mean_amount": 149.89,
            "median_amount": 119.15,
            "stability": 0.42,
            "mean_monthly_sum": 189.34,
            "count": 24,
            "start_date": "2019-03-25",
            "end_date": "2020-10-25",
            "mean_days_between_transactions": 25.22,
            "regularity": 0.5
        },
        {
            "description_normalized": "sdm deposit",
            "category": "TRANSFER",
            "direction": "INCOME",
            "is_recurring": false,
            "mean_amount": 705.0,
            "median_amount": 500.0,
            "stability": 0.36,
            "mean_monthly_sum": 940.0,
            "count": 8,
            "start_date": "2019-01-07",
            "end_date": "2020-02-29",
            "mean_days_between_transactions": 59.71,
            "regularity": 0.46
        },
        {
            "description_normalized": "mailchimp",
            "category": "RENT_AND_SERVICES",
            "direction": "EXPENSE",
            "is_recurring": false,
            "mean_amount": 40.37,
            "median_amount": 37.85,
            "stability": 0.78,
            "mean_monthly_sum": 55.05,
            "count": 15,
            "start_date": "2019-11-21",
            "end_date": "2020-10-21",
            "mean_days_between_transactions": 23.93,
            "regularity": 0.45
        },
        {
            "description_normalized": "dubai museums company",
            "category": "ENTERTAINMENT",
            "direction": "EXPENSE",
            "is_recurring": false,
            "mean_amount": 658.5,
            "median_amount": 330.71,
            "stability": 0.33,
            "mean_monthly_sum": 823.12,
            "count": 5,
            "start_date": "2019-03-31",
            "end_date": "2019-10-23",
            "mean_days_between_transactions": 51.5,
            "regularity": 0.44
        },
        {
            "description_normalized": "dubai museums company",
            "category": "ENTERTAINMENT",
            "direction": "EXPENSE",
            "is_recurring": false,
            "mean_amount": 28.5,
            "median_amount": 27.5,
            "stability": 0.79,
            "mean_monthly_sum": 28.5,
            "count": 4,
            "start_date": "2019-01-05",
            "end_date": "2019-07-10",
            "mean_days_between_transactions": 62.0,
            "regularity": 0.44
        },
        {
            "description_normalized": "aramex international",
            "category": "RENT_AND_SERVICES",
            "direction": "EXPENSE",
            "is_recurring": false,
            "mean_amount": 50.42,
            "median_amount": 52.59,
            "stability": 0.49,
            "mean_monthly_sum": 67.23,
            "count": 4,
            "start_date": "2019-12-05",
            "end_date": "2020-08-17",
            "mean_days_between_transactions": 85.33,
            "regularity": 0.43
        },
        {
            "description_normalized": "urban foods",
            "category": "GROCERIES",
            "direction": "EXPENSE",
            "is_recurring": false,
            "mean_amount": 49.39,
            "median_amount": 58.47,
            "stability": 0.47,
            "mean_monthly_sum": 61.74,
            "count": 5,
            "start_date": "2019-04-27",
            "end_date": "2020-07-31",
            "mean_days_between_transactions": 115.25,
            "regularity": 0.43
        },
        {
            "description_normalized": "galadari ice cream co ltd",
            "category": "RESTAURANTS_DINING",
            "direction": "EXPENSE",
            "is_recurring": false,
            "mean_amount": 19.0,
            "median_amount": 18.5,
            "stability": 0.56,
            "mean_monthly_sum": 28.5,
            "count": 6,
            "start_date": "2019-02-28",
            "end_date": "2019-12-15",
            "mean_days_between_transactions": 58.0,
            "regularity": 0.43
        },
        {
            "description_normalized": "cravia inc llc",
            "category": "RESTAURANTS_DINING",
            "direction": "EXPENSE",
            "is_recurring": false,
            "mean_amount": 27.73,
            "median_amount": 25.0,
            "stability": 0.67,
            "mean_monthly_sum": 69.33,
            "count": 15,
            "start_date": "2019-03-18",
            "end_date": "2019-08-26",
            "mean_days_between_transactions": 11.5,
            "regularity": 0.42
        },
        {
            "description_normalized": "cravia inc llc",
            "category": "RESTAURANTS_DINING",
            "direction": "EXPENSE",
            "is_recurring": false,
            "mean_amount": 106.87,
            "median_amount": 29.0,
            "stability": 0.22,
            "mean_monthly_sum": 167.94,
            "count": 11,
            "start_date": "2019-01-07",
            "end_date": "2019-12-14",
            "mean_days_between_transactions": 34.1,
            "regularity": 0.42
        },
        {
            "description_normalized": "leto cafe and restaurant",
            "category": "RESTAURANTS_DINING",
            "direction": "EXPENSE",
            "is_recurring": false,
            "mean_amount": 118.1,
            "median_amount": 111.7,
            "stability": 0.42,
            "mean_monthly_sum": 157.47,
            "count": 4,
            "start_date": "2019-03-23",
            "end_date": "2019-11-29",
            "mean_days_between_transactions": 83.67,
            "regularity": 0.41
        },
        {
            "description_normalized": "godaddy",
            "category": "RENT_AND_SERVICES",
            "direction": "EXPENSE",
            "is_recurring": false,
            "mean_amount": 110.33,
            "median_amount": 78.05,
            "stability": 0.42,
            "mean_monthly_sum": 147.11,
            "count": 4,
            "start_date": "2019-05-08",
            "end_date": "2020-05-08",
            "mean_days_between_transactions": 122.0,
            "regularity": 0.4
        },
        {
            "description_normalized": "emirates",
            "category": "TRAVEL",
            "direction": "EXPENSE",
            "is_recurring": false,
            "mean_amount": 2626.25,
            "median_amount": 2212.5,
            "stability": 0.46,
            "mean_monthly_sum": 2626.25,
            "count": 4,
            "start_date": "2019-02-28",
            "end_date": "2020-10-19",
            "mean_days_between_transactions": 199.67,
            "regularity": 0.4
        },
        {
            "description_normalized": "amazon",
            "category": "RETAIL",
            "direction": "INCOME",
            "is_recurring": false,
            "mean_amount": 22.76,
            "median_amount": 3.42,
            "stability": 0.21,
            "mean_monthly_sum": 30.34,
            "count": 8,
            "start_date": "2019-01-04",
            "end_date": "2019-12-09",
            "mean_days_between_transactions": 48.43,
            "regularity": 0.4
        },
        {
            "description_normalized": "beirut duty free airport",
            "category": "RETAIL",
            "direction": "EXPENSE",
            "is_recurring": false,
            "mean_amount": 152.39,
            "median_amount": 157.88,
            "stability": 0.71,
            "mean_monthly_sum": 190.49,
            "count": 5,
            "start_date": "2019-06-13",
            "end_date": "2020-10-02",
            "mean_days_between_transactions": 119.25,
            "regularity": 0.4
        },
        {
            "description_normalized": "rituals",
            "category": "TRANSPORT",
            "direction": "EXPENSE",
            "is_recurring": false,
            "mean_amount": 83.7,
            "median_amount": 85.53,
            "stability": 0.83,
            "mean_monthly_sum": 125.56,
            "count": 12,
            "start_date": "2019-04-13",
            "end_date": "2020-09-15",
            "mean_days_between_transactions": 47.36,
            "regularity": 0.39
        },
        {
            "description_normalized": "du",
            "category": "RENT_AND_SERVICES",
            "direction": "EXPENSE",
            "is_recurring": false,
            "mean_amount": 398.9,
            "median_amount": 397.95,
            "stability": 0.99,
            "mean_monthly_sum": 498.62,
            "count": 10,
            "start_date": "2019-02-09",
            "end_date": "2020-10-02",
            "mean_days_between_transactions": 66.78,
            "regularity": 0.39
        },
        {
            "description_normalized": "banknet transfer payment recvd thank you",
            "category": "TRANSFER",
            "direction": "INCOME",
            "is_recurring": false,
            "mean_amount": 9664.53,
            "median_amount": 8715.48,
            "stability": 0.37,
            "mean_monthly_sum": 18725.03,
            "count": 31,
            "start_date": "2019-01-12",
            "end_date": "2020-10-02",
            "mean_days_between_transactions": 20.97,
            "regularity": 0.37
        },
        {
            "description_normalized": "union co operative society",
            "category": "RENT_AND_SERVICES",
            "direction": "EXPENSE",
            "is_recurring": false,
            "mean_amount": 291.96,
            "median_amount": 367.56,
            "stability": 0.53,
            "mean_monthly_sum": 350.35,
            "count": 6,
            "start_date": "2019-02-04",
            "end_date": "2019-07-04",
            "mean_days_between_transactions": 30.0,
            "regularity": 0.37
        },
        {
            "description_normalized": "credit card payment",
            "category": "TRANSFER",
            "direction": "EXPENSE",
            "is_recurring": false,
            "mean_amount": 9664.53,
            "median_amount": 8715.48,
            "stability": 0.37,
            "mean_monthly_sum": 18725.03,
            "count": 31,
            "start_date": "2019-01-12",
            "end_date": "2020-10-02",
            "mean_days_between_transactions": 20.97,
            "regularity": 0.37
        },
        {
            "description_normalized": "outward clearing clrg chq deposit",
            "category": "TRANSFER",
            "direction": "INCOME",
            "is_recurring": false,
            "mean_amount": 1700.0,
            "median_amount": 1200.0,
            "stability": 0.5,
            "mean_monthly_sum": 3400.0,
            "count": 4,
            "start_date": "2020-07-26",
            "end_date": "2020-08-27",
            "mean_days_between_transactions": 10.67,
            "regularity": 0.37
        },
        {
            "description_normalized": "daiso japan value store",
            "category": "RETAIL",
            "direction": "EXPENSE",
            "is_recurring": false,
            "mean_amount": 38.45,
            "median_amount": 22.05,
            "stability": 0.43,
            "mean_monthly_sum": 48.06,
            "count": 5,
            "start_date": "2019-03-15",
            "end_date": "2020-08-22",
            "mean_days_between_transactions": 131.5,
            "regularity": 0.36
        },
        {
            "description_normalized": "service chgs atm",
            "category": "TRANSFER",
            "direction": "EXPENSE",
            "is_recurring": false,
            "mean_amount": 3942.11,
            "median_amount": 1500.0,
            "stability": 0.34,
            "mean_monthly_sum": 6809.09,
            "count": 19,
            "start_date": "2019-02-03",
            "end_date": "2020-08-17",
            "mean_days_between_transactions": 31.17,
            "regularity": 0.36
        },
        {
            "description_normalized": "homes for less general",
            "category": "RETAIL",
            "direction": "EXPENSE",
            "is_recurring": false,
            "mean_amount": 22.25,
            "median_amount": 17.5,
            "stability": 0.41,
            "mean_monthly_sum": 26.7,
            "count": 6,
            "start_date": "2019-03-14",
            "end_date": "2020-07-08",
            "mean_days_between_transactions": 96.4,
            "regularity": 0.36
        },
        {
            "description_normalized": "direct debit payment recvd thank you",
            "category": "TRANSFER",
            "direction": "INCOME",
            "is_recurring": false,
            "mean_amount": 5153.82,
            "median_amount": 5985.9,
            "stability": 0.41,
            "mean_monthly_sum": 7215.34,
            "count": 7,
            "start_date": "2019-04-19",
            "end_date": "2020-11-04",
            "mean_days_between_transactions": 94.17,
            "regularity": 0.35
        },
        {
            "description_normalized": "appetite catering service",
            "category": "RESTAURANTS_DINING",
            "direction": "EXPENSE",
            "is_recurring": false,
            "mean_amount": 35.03,
            "median_amount": 29.5,
            "stability": 0.57,
            "mean_monthly_sum": 52.55,
            "count": 6,
            "start_date": "2019-03-10",
            "end_date": "2019-10-16",
            "mean_days_between_transactions": 44.0,
            "regularity": 0.35
        },
        {
            "description_normalized": "j n k ladies beauty salon",
            "category": "HEALTH_AND_WELLBEING",
            "direction": "EXPENSE",
            "is_recurring": false,
            "mean_amount": 232.25,
            "median_amount": 225.0,
            "stability": 0.83,
            "mean_monthly_sum": 309.67,
            "count": 4,
            "start_date": "2019-01-03",
            "end_date": "2019-12-07",
            "mean_days_between_transactions": 112.67,
            "regularity": 0.35
        },
        {
            "description_normalized": "iherb",
            "category": "HEALTH_AND_WELLBEING",
            "direction": "EXPENSE",
            "is_recurring": false,
            "mean_amount": 228.37,
            "median_amount": 230.51,
            "stability": 0.71,
            "mean_monthly_sum": 380.62,
            "count": 10,
            "start_date": "2020-04-08",
            "end_date": "2020-10-13",
            "mean_days_between_transactions": 20.89,
            "regularity": 0.34
        },
        {
            "description_normalized": "kickstarter",
            "category": "RETAIL",
            "direction": "EXPENSE",
            "is_recurring": false,
            "mean_amount": 201.05,
            "median_amount": 173.8,
            "stability": 0.42,
            "mean_monthly_sum": 281.48,
            "count": 7,
            "start_date": "2020-05-20",
            "end_date": "2020-11-06",
            "mean_days_between_transactions": 28.33,
            "regularity": 0.33
        },
        {
            "description_normalized": "noon",
            "category": "LOANS_AND_INVESTMENTS",
            "direction": "EXPENSE",
            "is_recurring": false,
            "mean_amount": 706.17,
            "median_amount": 706.17,
            "stability": 1.0,
            "mean_monthly_sum": 1271.1,
            "count": 9,
            "start_date": "2020-01-25",
            "end_date": "2020-06-25",
            "mean_days_between_transactions": 19.0,
            "regularity": 0.33
        },
        {
            "description_normalized": "online banking transfer from bnk ref ####",
            "category": "TRANSFER",
            "direction": "EXPENSE",
            "is_recurring": false,
            "mean_amount": 4700.0,
            "median_amount": 4000.0,
            "stability": 0.41,
            "mean_monthly_sum": 6266.67,
            "count": 4,
            "start_date": "2019-01-06",
            "end_date": "2019-08-05",
            "mean_days_between_transactions": 70.33,
            "regularity": 0.33
        },
        {
            "description_normalized": "telegraphic trf ref #### ",
            "category": "TRANSFER",
            "direction": "EXPENSE",
            "is_recurring": false,
            "mean_amount": 7428.96,
            "median_amount": 7370.0,
            "stability": 0.98,
            "mean_monthly_sum": 18572.4,
            "count": 5,
            "start_date": "2020-05-18",
            "end_date": "2020-06-20",
            "mean_days_between_transactions": 8.25,
            "regularity": 0.32
        },
        {
            "description_normalized": "cravia inc llc",
            "category": "RESTAURANTS_DINING",
            "direction": "EXPENSE",
            "is_recurring": false,
            "mean_amount": 548.36,
            "median_amount": 75.2,
            "stability": 0.25,
            "mean_monthly_sum": 731.15,
            "count": 4,
            "start_date": "2019-02-28",
            "end_date": "2020-08-29",
            "mean_days_between_transactions": 182.67,
            "regularity": 0.32
        },
        {
            "description_normalized": "chloes beauty hair and na",
            "category": "HEALTH_AND_WELLBEING",
            "direction": "EXPENSE",
            "is_recurring": false,
            "mean_amount": 487.88,
            "median_amount": 557.0,
            "stability": 0.73,
            "mean_monthly_sum": 650.5,
            "count": 8,
            "start_date": "2019-08-14",
            "end_date": "2020-11-02",
            "mean_days_between_transactions": 63.71,
            "regularity": 0.32
        },
        {
            "description_normalized": "cars taxi services co llc",
            "category": "TRANSPORT",
            "direction": "EXPENSE",
            "is_recurring": false,
            "mean_amount": 17.92,
            "median_amount": 15.25,
            "stability": 0.59,
            "mean_monthly_sum": 21.5,
            "count": 6,
            "start_date": "2019-03-18",
            "end_date": "2019-11-27",
            "mean_days_between_transactions": 50.8,
            "regularity": 0.32
        },
        {
            "description_normalized": "kickstarter good girl",
            "category": "RETAIL",
            "direction": "EXPENSE",
            "is_recurring": false,
            "mean_amount": 176.99,
            "median_amount": 159.13,
            "stability": 0.58,
            "mean_monthly_sum": 309.73,
            "count": 7,
            "start_date": "2020-02-07",
            "end_date": "2020-10-09",
            "mean_days_between_transactions": 40.83,
            "regularity": 0.31
        },
        {
            "description_normalized": "dubai museums company",
            "category": "ENTERTAINMENT",
            "direction": "EXPENSE",
            "is_recurring": false,
            "mean_amount": 25.46,
            "median_amount": 26.4,
            "stability": 0.54,
            "mean_monthly_sum": 33.95,
            "count": 4,
            "start_date": "2019-04-22",
            "end_date": "2020-07-22",
            "mean_days_between_transactions": 152.33,
            "regularity": 0.31
        },
        {
            "description_normalized": "zomato media private limited",
            "category": "RESTAURANTS_DINING",
            "direction": "EXPENSE",
            "is_recurring": false,
            "mean_amount": 78.96,
            "median_amount": 66.25,
            "stability": 0.52,
            "mean_monthly_sum": 252.68,
            "count": 32,
            "start_date": "2020-02-08",
            "end_date": "2020-12-03",
            "mean_days_between_transactions": 9.65,
            "regularity": 0.31
        },
        {
            "description_normalized": "carrefour",
            "category": "GROCERIES",
            "direction": "EXPENSE",
            "is_recurring": false,
            "mean_amount": 135.64,
            "median_amount": 78.6,
            "stability": 0.31,
            "mean_monthly_sum": 501.88,
            "count": 74,
            "start_date": "2019-01-04",
            "end_date": "2020-11-08",
            "mean_days_between_transactions": 9.23,
            "regularity": 0.31
        },
        {
            "description_normalized": "online banking transfer to ####",
            "category": "RENT_AND_SERVICES",
            "direction": "EXPENSE",
            "is_recurring": false,
            "mean_amount": 442.4,
            "median_amount": 286.24,
            "stability": 0.3,
            "mean_monthly_sum": 786.49,
            "count": 16,
            "start_date": "2019-10-12",
            "end_date": "2020-10-02",
            "mean_days_between_transactions": 23.73,
            "regularity": 0.31
        },
        {
            "description_normalized": "choithram green community",
            "category": "GROCERIES",
            "direction": "EXPENSE",
            "is_recurring": false,
            "mean_amount": 33.55,
            "median_amount": 31.0,
            "stability": 0.55,
            "mean_monthly_sum": 92.28,
            "count": 11,
            "start_date": "2020-05-08",
            "end_date": "2020-12-09",
            "mean_days_between_transactions": 21.5,
            "regularity": 0.3
        },
        {
            "description_normalized": "uber",
            "category": "TRANSPORT",
            "direction": "EXPENSE",
            "is_recurring": false,
            "mean_amount": 57.1,
            "median_amount": 42.68,
            "stability": 0.44,
            "mean_monthly_sum": 68.52,
            "count": 6,
            "start_date": "2019-04-17",
            "end_date": "2020-05-02",
            "mean_days_between_transactions": 76.2,
            "regularity": 0.3
        },
        {
            "description_normalized": "billed finance charges",
            "category": "BANK_FEES_AND_CHARGES",
            "direction": "EXPENSE",
            "is_recurring": false,
            "mean_amount": 443.23,
            "median_amount": 402.43,
            "stability": 0.8,
            "mean_monthly_sum": 886.46,
            "count": 6,
            "start_date": "2020-03-25",
            "end_date": "2020-05-25",
            "mean_days_between_transactions": 12.2,
            "regularity": 0.3
        },
        {
            "description_normalized": "du",
            "category": "RENT_AND_SERVICES",
            "direction": "EXPENSE",
            "is_recurring": false,
            "mean_amount": 401.45,
            "median_amount": 397.95,
            "stability": 0.97,
            "mean_monthly_sum": 602.17,
            "count": 3,
            "start_date": "2020-02-09",
            "end_date": "2020-05-04",
            "mean_days_between_transactions": 42.5,
            "regularity": 0.29
        },
        {
            "description_normalized": "s a s express building mat",
            "category": "TRANSPORT",
            "direction": "EXPENSE",
            "is_recurring": false,
            "mean_amount": 124.69,
            "median_amount": 99.75,
            "stability": 0.47,
            "mean_monthly_sum": 498.75,
            "count": 4,
            "start_date": "2020-08-15",
            "end_date": "2020-08-23",
            "mean_days_between_transactions": 2.67,
            "regularity": 0.29
        },
        {
            "description_normalized": "smart dubai government https epaym are",
            "category": "GOVERNMENT",
            "direction": "EXPENSE",
            "is_recurring": false,
            "mean_amount": 336.36,
            "median_amount": 359.38,
            "stability": 0.66,
            "mean_monthly_sum": 739.99,
            "count": 22,
            "start_date": "2019-01-07",
            "end_date": "2020-10-02",
            "mean_days_between_transactions": 30.19,
            "regularity": 0.29
        },
        {
            "description_normalized": "tamimi markets",
            "category": "OTHER",
            "direction": "INCOME",
            "is_recurring": false,
            "mean_amount": 71.1,
            "median_amount": 64.47,
            "stability": 0.59,
            "mean_monthly_sum": 106.65,
            "count": 3,
            "start_date": "2020-01-28",
            "end_date": "2020-02-02",
            "mean_days_between_transactions": 2.5,
            "regularity": 0.29
        },
        {
            "description_normalized": "sb transfer sb ref arabnet consultancy b o arabnet fz",
            "category": "RENT_AND_SERVICES",
            "direction": "INCOME",
            "is_recurring": false,
            "mean_amount": 18995.33,
            "median_amount": 22148.0,
            "stability": 0.67,
            "mean_monthly_sum": 28493.0,
            "count": 3,
            "start_date": "2020-02-26",
            "end_date": "2020-05-21",
            "mean_days_between_transactions": 42.5,
            "regularity": 0.29
        },
        {
            "description_normalized": "waitrose fine fare",
            "category": "RETAIL",
            "direction": "EXPENSE",
            "is_recurring": false,
            "mean_amount": 335.89,
            "median_amount": 164.0,
            "stability": 0.32,
            "mean_monthly_sum": 503.84,
            "count": 3,
            "start_date": "2019-04-15",
            "end_date": "2020-02-16",
            "mean_days_between_transactions": 153.5,
            "regularity": 0.29
        },
        {
            "description_normalized": "crate and barrel",
            "category": "RETAIL",
            "direction": "INCOME",
            "is_recurring": false,
            "mean_amount": 50.5,
            "median_amount": 55.1,
            "stability": 0.79,
            "mean_monthly_sum": 75.75,
            "count": 3,
            "start_date": "2020-01-03",
            "end_date": "2020-11-04",
            "mean_days_between_transactions": 153.0,
            "regularity": 0.29
        },
        {
            "description_normalized": "tokaikiosk giftkioskyae",
            "category": "OTHER",
            "direction": "EXPENSE",
            "is_recurring": false,
            "mean_amount": 391.69,
            "median_amount": 68.39,
            "stability": 0.29,
            "mean_monthly_sum": 1958.45,
            "count": 5,
            "start_date": "2019-04-15",
            "end_date": "2019-04-19",
            "mean_days_between_transactions": 1.0,
            "regularity": 0.29
        },
        {
            "description_normalized": "molecule restaurant",
            "category": "RESTAURANTS_DINING",
            "direction": "EXPENSE",
            "is_recurring": false,
            "mean_amount": 41.11,
            "median_amount": 40.32,
            "stability": 0.48,
            "mean_monthly_sum": 61.66,
            "count": 3,
            "start_date": "2019-05-10",
            "end_date": "2020-08-28",
            "mean_days_between_transactions": 238.0,
            "regularity": 0.29
        },
        {
            "description_normalized": "service chgs atm card no dubai ae ",
            "category": "GROCERIES",
            "direction": "EXPENSE",
            "is_recurring": false,
            "mean_amount": 65.34,
            "median_amount": 55.43,
            "stability": 0.54,
            "mean_monthly_sum": 120.62,
            "count": 24,
            "start_date": "2019-03-31",
            "end_date": "2020-10-13",
            "mean_days_between_transactions": 24.43,
            "regularity": 0.29
        },
        {
            "description_normalized": "urbanclap technologies",
            "category": "RENT_AND_SERVICES",
            "direction": "EXPENSE",
            "is_recurring": false,
            "mean_amount": 95.35,
            "median_amount": 92.0,
            "stability": 0.66,
            "mean_monthly_sum": 147.36,
            "count": 17,
            "start_date": "2019-02-09",
            "end_date": "2020-12-08",
            "mean_days_between_transactions": 41.75,
            "regularity": 0.29
        },
        {
            "description_normalized": "carrefour",
            "category": "RESTAURANTS_DINING",
            "direction": "EXPENSE",
            "is_recurring": false,
            "mean_amount": 146.95,
            "median_amount": 165.0,
            "stability": 0.46,
            "mean_monthly_sum": 220.42,
            "count": 3,
            "start_date": "2019-03-15",
            "end_date": "2019-08-23",
            "mean_days_between_transactions": 80.5,
            "regularity": 0.29
        },
        {
            "description_normalized": "american eagle",
            "category": "RETAIL",
            "direction": "EXPENSE",
            "is_recurring": false,
            "mean_amount": 202.95,
            "median_amount": 227.29,
            "stability": 0.48,
            "mean_monthly_sum": 270.6,
            "count": 4,
            "start_date": "2019-03-30",
            "end_date": "2020-09-15",
            "mean_days_between_transactions": 178.33,
            "regularity": 0.29
        },
        {
            "description_normalized": "souq al bahar foa fish",
            "category": "RESTAURANTS_DINING",
            "direction": "EXPENSE",
            "is_recurring": false,
            "mean_amount": 108.0,
            "median_amount": 122.0,
            "stability": 0.72,
            "mean_monthly_sum": 162.0,
            "count": 3,
            "start_date": "2019-02-08",
            "end_date": "2020-04-17",
            "mean_days_between_transactions": 217.0,
            "regularity": 0.29
        },
        {
            "description_normalized": "the dome meddental cli",
            "category": "HEALTH_AND_WELLBEING",
            "direction": "EXPENSE",
            "is_recurring": false,
            "mean_amount": 83.34,
            "median_amount": 47.98,
            "stability": 0.33,
            "mean_monthly_sum": 166.69,
            "count": 8,
            "start_date": "2019-04-25",
            "end_date": "2020-06-08",
            "mean_days_between_transactions": 58.57,
            "regularity": 0.29
        },
        {
            "description_normalized": "online banking transfer from bnk ref ####",
            "category": "TRANSFER",
            "direction": "INCOME",
            "is_recurring": false,
            "mean_amount": 1227.88,
            "median_amount": 459.5,
            "stability": 0.27,
            "mean_monthly_sum": 4044.78,
            "count": 56,
            "start_date": "2019-01-04",
            "end_date": "2020-12-06",
            "mean_days_between_transactions": 12.76,
            "regularity": 0.28
        },
        {
            "description_normalized": "alamtyazat international",
            "category": "OTHER",
            "direction": "EXPENSE",
            "is_recurring": false,
            "mean_amount": 83.72,
            "median_amount": 88.16,
            "stability": 0.63,
            "mean_monthly_sum": 111.63,
            "count": 4,
            "start_date": "2020-01-28",
            "end_date": "2020-04-02",
            "mean_days_between_transactions": 21.67,
            "regularity": 0.28
        },
        {
            "description_normalized": "credit card payment ",
            "category": "LOANS_AND_INVESTMENTS",
            "direction": "EXPENSE",
            "is_recurring": false,
            "mean_amount": 5031.42,
            "median_amount": 4236.18,
            "stability": 0.45,
            "mean_monthly_sum": 6289.28,
            "count": 5,
            "start_date": "2019-04-19",
            "end_date": "2020-03-21",
            "mean_days_between_transactions": 84.25,
            "regularity": 0.28
        },
        {
            "description_normalized": "liv transfer social transfer liv ref msg for mum and dad",
            "category": "TRANSFER",
            "direction": "INCOME",
            "is_recurring": false,
            "mean_amount": 5357.14,
            "median_amount": 5000.0,
            "stability": 0.56,
            "mean_monthly_sum": 12500.0,
            "count": 7,
            "start_date": "2020-02-26",
            "end_date": "2020-07-30",
            "mean_days_between_transactions": 25.83,
            "regularity": 0.28
        },
        {
            "description_normalized": "inward clearing chq no ####",
            "category": "TRANSFER",
            "direction": "EXPENSE",
            "is_recurring": false,
            "mean_amount": 31000.0,
            "median_amount": 31000.0,
            "stability": 1.0,
            "mean_monthly_sum": 62000.0,
            "count": 4,
            "start_date": "2019-02-09",
            "end_date": "2020-01-03",
            "mean_days_between_transactions": 109.33,
            "regularity": 0.27
        },
        {
            "description_normalized": "amazon",
            "category": "RETAIL",
            "direction": "EXPENSE",
            "is_recurring": false,
            "mean_amount": 398.3,
            "median_amount": 195.59,
            "stability": 0.42,
            "mean_monthly_sum": 625.9,
            "count": 11,
            "start_date": "2019-01-04",
            "end_date": "2020-09-18",
            "mean_days_between_transactions": 62.3,
            "regularity": 0.27
        },
        {
            "description_normalized": "awani housewares",
            "category": "RETAIL",
            "direction": "EXPENSE",
            "is_recurring": false,
            "mean_amount": 64.28,
            "median_amount": 54.05,
            "stability": 0.62,
            "mean_monthly_sum": 128.55,
            "count": 4,
            "start_date": "2019-10-10",
            "end_date": "2020-05-22",
            "mean_days_between_transactions": 75.0,
            "regularity": 0.27
        },
        {
            "description_normalized": "apple com bill itunes com irl",
            "category": "ENTERTAINMENT",
            "direction": "EXPENSE",
            "is_recurring": false,
            "mean_amount": 19.37,
            "median_amount": 7.29,
            "stability": 0.27,
            "mean_monthly_sum": 33.89,
            "count": 14,
            "start_date": "2019-05-07",
            "end_date": "2020-11-09",
            "mean_days_between_transactions": 42.46,
            "regularity": 0.27
        },
        {
            "description_normalized": "etisalat",
            "category": "RENT_AND_SERVICES",
            "direction": "EXPENSE",
            "is_recurring": false,
            "mean_amount": 380.63,
            "median_amount": 250.37,
            "stability": 0.48,
            "mean_monthly_sum": 815.63,
            "count": 15,
            "start_date": "2019-01-04",
            "end_date": "2020-05-03",
            "mean_days_between_transactions": 34.64,
            "regularity": 0.26
        },
        {
            "description_normalized": "caribou coffee",
            "category": "RESTAURANTS_DINING",
            "direction": "EXPENSE",
            "is_recurring": false,
            "mean_amount": 21.08,
            "median_amount": 19.0,
            "stability": 0.68,
            "mean_monthly_sum": 36.14,
            "count": 24,
            "start_date": "2019-01-05",
            "end_date": "2020-10-03",
            "mean_days_between_transactions": 27.7,
            "regularity": 0.26
        },
        {
            "description_normalized": "service chgs atm card no value added tax vat ",
            "category": "BANK_FEES_AND_CHARGES",
            "direction": "EXPENSE",
            "is_recurring": false,
            "mean_amount": 1.0,
            "median_amount": 1.0,
            "stability": 1.0,
            "mean_monthly_sum": 2.0,
            "count": 4,
            "start_date": "2019-05-31",
            "end_date": "2019-12-06",
            "mean_days_between_transactions": 63.0,
            "regularity": 0.25
        },
        {
            "description_normalized": "majid al futtaim",
            "category": "RETAIL",
            "direction": "EXPENSE",
            "is_recurring": false,
            "mean_amount": 64.88,
            "median_amount": 55.1,
            "stability": 0.59,
            "mean_monthly_sum": 129.77,
            "count": 6,
            "start_date": "2020-01-04",
            "end_date": "2020-12-03",
            "mean_days_between_transactions": 66.8,
            "regularity": 0.25
        },
        {
            "description_normalized": "outward clearing clrg chq deposit chq no bank of baroda dubai main office",
            "category": "TRANSFER",
            "direction": "INCOME",
            "is_recurring": false,
            "mean_amount": 7213.59,
            "median_amount": 2709.68,
            "stability": 0.34,
            "mean_monthly_sum": 10099.03,
            "count": 7,
            "start_date": "2019-04-30",
            "end_date": "2020-11-04",
            "mean_days_between_transactions": 92.33,
            "regularity": 0.25
        },
        {
            "description_normalized": "transfer ",
            "category": "TRANSFER",
            "direction": "EXPENSE",
            "is_recurring": false,
            "mean_amount": 4848.0,
            "median_amount": 4848.0,
            "stability": 0.38,
            "mean_monthly_sum": 9695.99,
            "count": 4,
            "start_date": "2020-08-04",
            "end_date": "2020-11-04",
            "mean_days_between_transactions": 30.67,
            "regularity": 0.25
        },
        {
            "description_normalized": "morjan pharmacy saida",
            "category": "HEALTH_AND_WELLBEING",
            "direction": "EXPENSE",
            "is_recurring": false,
            "mean_amount": 279.53,
            "median_amount": 295.53,
            "stability": 0.42,
            "mean_monthly_sum": 559.06,
            "count": 6,
            "start_date": "2019-05-28",
            "end_date": "2020-01-01",
            "mean_days_between_transactions": 43.6,
            "regularity": 0.25
        },
        {
            "description_normalized": "chatfood",
            "category": "RESTAURANTS_DINING",
            "direction": "EXPENSE",
            "is_recurring": false,
            "mean_amount": 85.0,
            "median_amount": 85.0,
            "stability": 0.66,
            "mean_monthly_sum": 170.0,
            "count": 4,
            "start_date": "2020-05-28",
            "end_date": "2020-06-06",
            "mean_days_between_transactions": 3.0,
            "regularity": 0.25
        },
        {
            "description_normalized": "inward remittance ocean x and partner co settlement of bills providing free lancer consulting",
            "category": "TRANSFER",
            "direction": "INCOME",
            "is_recurring": false,
            "mean_amount": 36347.35,
            "median_amount": 36347.35,
            "stability": 1.0,
            "mean_monthly_sum": 72694.7,
            "count": 4,
            "start_date": "2020-04-20",
            "end_date": "2020-05-18",
            "mean_days_between_transactions": 9.33,
            "regularity": 0.25
        },
        {
            "description_normalized": "pharmacy llc",
            "category": "HEALTH_AND_WELLBEING",
            "direction": "EXPENSE",
            "is_recurring": false,
            "mean_amount": 235.48,
            "median_amount": 161.5,
            "stability": 0.33,
            "mean_monthly_sum": 729.99,
            "count": 31,
            "start_date": "2019-04-09",
            "end_date": "2020-07-22",
            "mean_days_between_transactions": 15.67,
            "regularity": 0.24
        },
        {
            "description_normalized": "google gsuite digital",
            "category": "RENT_AND_SERVICES",
            "direction": "EXPENSE",
            "is_recurring": false,
            "mean_amount": 45.46,
            "median_amount": 45.46,
            "stability": 1.0,
            "mean_monthly_sum": 136.38,
            "count": 6,
            "start_date": "2020-01-01",
            "end_date": "2020-02-09",
            "mean_days_between_transactions": 7.8,
            "regularity": 0.24
        },
        {
            "description_normalized": "noon",
            "category": "RETAIL",
            "direction": "INCOME",
            "is_recurring": false,
            "mean_amount": 74.8,
            "median_amount": 40.17,
            "stability": 0.33,
            "mean_monthly_sum": 299.19,
            "count": 12,
            "start_date": "2020-04-05",
            "end_date": "2020-07-24",
            "mean_days_between_transactions": 10.0,
            "regularity": 0.24
        },
        {
            "description_normalized": "careem",
            "category": "TRANSPORT",
            "direction": "EXPENSE",
            "is_recurring": false,
            "mean_amount": 36.09,
            "median_amount": 33.33,
            "stability": 0.51,
            "mean_monthly_sum": 137.15,
            "count": 19,
            "start_date": "2020-01-02",
            "end_date": "2020-05-02",
            "mean_days_between_transactions": 6.72,
            "regularity": 0.24
        },
        {
            "description_normalized": "homes for less general",
            "category": "RETAIL",
            "direction": "EXPENSE",
            "is_recurring": false,
            "mean_amount": 335.6,
            "median_amount": 85.0,
            "stability": 0.34,
            "mean_monthly_sum": 839.0,
            "count": 5,
            "start_date": "2019-03-16",
            "end_date": "2020-08-29",
            "mean_days_between_transactions": 133.0,
            "regularity": 0.23
        },
        {
            "description_normalized": "horizon cafe",
            "category": "RESTAURANTS_DINING",
            "direction": "INCOME",
            "is_recurring": false,
            "mean_amount": 194.64,
            "median_amount": 94.06,
            "stability": 0.34,
            "mean_monthly_sum": 583.93,
            "count": 21,
            "start_date": "2019-08-12",
            "end_date": "2020-08-25",
            "mean_days_between_transactions": 18.95,
            "regularity": 0.23
        },
        {
            "description_normalized": "google",
            "category": "RENT_AND_SERVICES",
            "direction": "EXPENSE",
            "is_recurring": false,
            "mean_amount": 43.07,
            "median_amount": 45.46,
            "stability": 0.79,
            "mean_monthly_sum": 86.14,
            "count": 8,
            "start_date": "2019-01-12",
            "end_date": "2020-02-08",
            "mean_days_between_transactions": 56.0,
            "regularity": 0.22
        },
        {
            "description_normalized": "scaleway",
            "category": "GROCERIES",
            "direction": "EXPENSE",
            "is_recurring": false,
            "mean_amount": 27.5,
            "median_amount": 17.78,
            "stability": 0.57,
            "mean_monthly_sum": 58.93,
            "count": 15,
            "start_date": "2019-04-12",
            "end_date": "2020-07-02",
            "mean_days_between_transactions": 31.93,
            "regularity": 0.21
        },
        {
            "description_normalized": "ikea",
            "category": "RETAIL",
            "direction": "EXPENSE",
            "is_recurring": false,
            "mean_amount": 773.82,
            "median_amount": 163.0,
            "stability": 0.21,
            "mean_monthly_sum": 1064.0,
            "count": 11,
            "start_date": "2019-02-28",
            "end_date": "2020-09-19",
            "mean_days_between_transactions": 56.9,
            "regularity": 0.21
        },
        {
            "description_normalized": "gulf film llc",
            "category": "ENTERTAINMENT",
            "direction": "EXPENSE",
            "is_recurring": false,
            "mean_amount": 47.89,
            "median_amount": 33.0,
            "stability": 0.31,
            "mean_monthly_sum": 600.6,
            "count": 301,
            "start_date": "2019-01-03",
            "end_date": "2020-12-02",
            "mean_days_between_transactions": 2.33,
            "regularity": 0.2
        },
        {
            "description_normalized": "telegraphic trf ref num #### ",
            "category": "TRANSFER",
            "direction": "EXPENSE",
            "is_recurring": false,
            "mean_amount": 4730.0,
            "median_amount": 2026.75,
            "stability": 0.44,
            "mean_monthly_sum": 16555.0,
            "count": 7,
            "start_date": "2019-05-30",
            "end_date": "2020-05-22",
            "mean_days_between_transactions": 59.67,
            "regularity": 0.2
        },
        {
            "description_normalized": "noon",
            "category": "RETAIL",
            "direction": "EXPENSE",
            "is_recurring": false,
            "mean_amount": 308.9,
            "median_amount": 115.7,
            "stability": 0.22,
            "mean_monthly_sum": 1164.31,
            "count": 49,
            "start_date": "2019-03-21",
            "end_date": "2020-10-08",
            "mean_days_between_transactions": 11.81,
            "regularity": 0.19
        },
        {
            "description_normalized": "blackwell",
            "category": "RETAIL",
            "direction": "EXPENSE",
            "is_recurring": false,
            "mean_amount": 88.36,
            "median_amount": 87.11,
            "stability": 0.68,
            "mean_monthly_sum": 1413.82,
            "count": 16,
            "start_date": "2020-04-20",
            "end_date": "2020-04-24",
            "mean_days_between_transactions": 0.27,
            "regularity": 0.18
        },
        {
            "description_normalized": "waitrose fine fare",
            "category": "GROCERIES",
            "direction": "EXPENSE",
            "is_recurring": false,
            "mean_amount": 53.56,
            "median_amount": 53.5,
            "stability": 0.63,
            "mean_monthly_sum": 173.02,
            "count": 42,
            "start_date": "2019-03-03",
            "end_date": "2020-12-02",
            "mean_days_between_transactions": 15.61,
            "regularity": 0.17
        }
    ]
}

export default cashflow